/**
 * Environment utility functions
 */

/**
 * Get user-friendly environment name from Firebase project ID
 */
export const getEnvironmentName = (projectId: string): string => {
  switch (projectId) {
    case "schedana-demo":
      return "Demo";
    case "schedana-dev-f94d2":
      return "Development";
    case "schedana-invite":
      return "Production";
    default:
      return projectId;
  }
};

/**
 * Get current environment name from environment variables
 */
export const getCurrentEnvironmentName = (): string => {
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (!projectId) {
    return "Unknown";
  }
  return getEnvironmentName(projectId);
};

/**
 * Check if current environment is production
 */
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === "production";
};

/**
 * Check if environment name should be displayed
 */
export const shouldShowEnvironmentName = (): boolean => {
  return !isProduction() && !!process.env.REACT_APP_FIREBASE_PROJECT_ID;
};
